<template>
  <v-card flat>
    <v-layout row
              wrap>
      <v-flex xs8
              class="pa-0">
        <v-card flat>
          <v-card-title class="pt-0 pl-0">
            <div class="text-no-wrap dashboard-title">Teaching Points</div>
          </v-card-title>
          <v-card-text class="pa-0 blue-text-normal">
            <v-layout row
                      wrap
                      class="teaching-points">
              <v-flex xs4
                      v-for="(item,index) in lists"
                      :class="`${index > 2 ? 'pb-2': 'pb-3'}`"
                      :key="'data'+index">
                <v-card-title class="pa-0 display-flex align-items-start flex-direction-column">
                  <div class="points">
                    <span class="blue-title-2 font-weight-bold font-20">{{getDatas(item)}}</span>
                    <div class="blue-title">{{item.title}}</div>
                  </div>
                </v-card-title>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs4>
        <v-card flat>
          <div class="display-flex align-items-end total-points" >
              <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
                  <span>{{getScore(user.teachingPoints)}}</span>
                  <span>Total Points</span>
                </div>
                <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
                  <span>{{getScore(user.scoreOfTheMonth)}}</span>
                  <span>Points of Month</span>
                </div>
            </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
import {
  mapGetters
} from 'vuex'
export default {
  name: 'personInfo',
  props: {
    perosonInfos: {
      patirot: ''
    }
  },
  data: () => ({
    lists: [
      { title: 'Completion', type: 'completion' },
      { title: 'Good Rating', type: 'goodRating' },
      { title: 'Absences', type: 'absences' },
      { title: 'Bad Rating', type: 'badRating' },
      { title: 'Cancellation', type: 'cancellation' },
      { title: 'Other', type: 'other' }
    ],
    perosonInfo: {},
    imgError: false
  }),
  computed: {
    ...mapGetters([
      'user'
    ]),
    imgSrc () {
      return this.imgError ? this.user.defaultAvatar : this.user.avatar
    }
  },
  methods: {
    showPoints () {
      this.$store.commit('setPointDialog', true)
    },
    getScore (score) {
      return score >= 0 ? `+${score}` : score
    },
    getDatas (item) {
      var _score = this.user[item.type]
      if (_score >= 0) { return '+' + _score }
      return _score
    }
  }
}
</script>
<style lang="scss" scoped>
.teaching-points{
  position: relative;
  left: -5px;
}
.points{
  width:90px;
  text-align:center;
}
.total-points {
  justify-content:space-between;
}
@media only screen and (max-width: 1666px) {
    .total-points {
        flex-direction: column;
        .dashboard-subtitle:last-child{
          margin-top:20px
        }
    }
}
</style>
